
import AuthService from "../service/AuthService";
import AuthStorage from "../storage/AuthStorage";


export default class AuthController {

	 async VerifyConexion() {

		const authService = new AuthService();

		let response = await authService.VerifyConexion();

		return response;

	}

	async configSubdomain(subdomain) {

		console.log("configSubdomain22.js");
		
		const authService = new AuthService();

		let response = await authService.getSuscripcionFromSubdomain(subdomain);
		let data = response.data;

		const authStorage = new AuthStorage(window.location.pathname);
		
		if (data.idSuscripcion !== undefined) {

			authStorage.setConfigSubdomain(data);

			return data;
		}
	}

	logout() {

		console.log("logout.js");
		const authStorage = new AuthStorage(window.location.pathname);

		authStorage.removeCurrentUser();
		//localStorage.removeItem('currentUser');

	}

	async loginUser(loginPayload) {

		const authStorage = new AuthStorage(window.location.pathname);
		const authService = new AuthService();

		try {

			let resLogin = await authService.login(loginPayload.idSuscripcion, loginPayload.idEmpresa, loginPayload.idioma, loginPayload.userName, loginPayload.password);

			console.log("resLogin,", resLogin);

			if (resLogin.loginOK) {

				const payloadLogin = {
					userName: resLogin.userName,
					idEmpresa: resLogin.idEmpresa,
					idSuscripcion: resLogin.idSuscripcion,
					idioma: resLogin.idioma,
					token: resLogin.token,
					subdomain: loginPayload.subdomain,
					sessionGUID: resLogin.sessionGUID,
					documentoInvitado: resLogin.documentoInvitado || ''
				};

				console.log("result login", payloadLogin);

				authStorage.setCurrentUser(payloadLogin);

				let tokenPayload = {
					userName: resLogin.userName,
					sessionGUID: resLogin.sessionGUID
				};

				return await this.GetTokenAutorization(tokenPayload);
			}

			return resLogin;

		} catch (error) {
			console.log("Error ", error);
		}
	}

	async getClientIP() {

		const authStorage = new AuthStorage(window.location.pathname);
		const authService = new AuthService();

		try {

			let res = "";
			let clientIP = await authService.getClientIP();

			if (clientIP !== undefined && clientIP !==null){
				res = clientIP.ipCliente;
			}

			console.log("resLogin,", res);

			return res;

		} catch (error) {
			console.log("Error ", error);
		}
	}

	async loginVisitUser(loginPayload) {

		const authStorage = new AuthStorage(window.location.pathname);
		const authService = new AuthService();

		try {

			let resLogin = await authService.loginVisitUser(loginPayload.idSuscripcion, loginPayload.idEmpresa, loginPayload.idioma, loginPayload.userName, loginPayload.password, loginPayload.documentoInvitado);

			console.log("resLogin,", resLogin);

			if (resLogin.loginOK) {

				const payloadLogin = {
					userName: resLogin.userName,
					idEmpresa: resLogin.idEmpresa,
					idSuscripcion: resLogin.idSuscripcion,
					idioma: resLogin.idioma,
					token: resLogin.token,
					subdomain: loginPayload.subdomain,
					sessionGUID: resLogin.sessionGUID,
					documentoInvitado: loginPayload.documentoInvitado,
				};

				console.log("result login", payloadLogin);

				authStorage.setCurrentUser(payloadLogin);

				let tokenPayload = {
					userName: resLogin.userName,
					sessionGUID: resLogin.sessionGUID
				};

				return await this.GetTokenAutorization(tokenPayload);
			}

			return resLogin;

		} catch (error) {
			console.log("Error ", error);
		}
	}

	async loginUserDetected(detectedLogin) {

		const authStorage = new AuthStorage(window.location.pathname);
		const authService = new AuthService();

		try {

			//let resLogin = await authService.loginVisitUser(loginPayload.idSuscripcion, loginPayload.idEmpresa, loginPayload.idioma, loginPayload.userName, loginPayload.password, loginPayload.documentoInvitado);

			let resLogin = { ...detectedLogin };

			console.log("resLogin,", resLogin);

			if (resLogin.loginOK) {

				const payloadLogin = {
					userName: resLogin.userName,
					idEmpresa: resLogin.idEmpresa,
					idSuscripcion: resLogin.idSuscripcion,
					idioma: resLogin.idioma,
					token: resLogin.token,
					subdomain: resLogin.subdomain,
					sessionGUID: resLogin.sessionGUID,
					documentoInvitado: resLogin.documentoInvitado || '',
				};

				console.log("result login", payloadLogin);

				authStorage.setCurrentUser(payloadLogin);

				let tokenPayload = {
					userName: resLogin.userName,
					sessionGUID: resLogin.sessionGUID
				};

				return await this.GetTokenAutorization(tokenPayload);
			}

			return resLogin;

		} catch (error) {
			console.log("Error ", error);
		}
	}

	async GetTokenAutorization(tokenPayload) {

		const authStorage = new AuthStorage(window.location.pathname);
		const authService = new AuthService();

		try {

			console.log(" details", tokenPayload);

			let token = await authService.GetTokenAutorization(tokenPayload.userName, tokenPayload.sessionGUID);

			const currentUser = authStorage.GetCurrentUser();
			console.log(currentUser);
			const payloadToken2 = { ...currentUser, token: token }

			//AuthStorage.setCurrentTokenAutorization(payloadToken2);
			authStorage.setCurrentUser(payloadToken2);


			return payloadToken2;

		} catch (error) {
			console.log("Error ", error);
		}
	}

	async getIpAddress(tokenPayload) {

		const authStorage = new AuthStorage(window.location.pathname);
		const authService = new AuthService();

		try {

			console.log(" details", tokenPayload);

			let token = await authService.GetTokenAutorization(tokenPayload.userName, tokenPayload.sessionGUID);

			const currentUser = authStorage.GetCurrentUser();
			console.log(currentUser);
			const payloadToken2 = { ...currentUser, token: token }

			//AuthStorage.setCurrentTokenAutorization(payloadToken2);
			authStorage.setCurrentUser(payloadToken2);


			return payloadToken2;

		} catch (error) {
			console.log("Error ", error);
		}
	}


	// para el tema del token de autorizacion




}
